import { render } from "./NavElement.vue?vue&type=template&id=76423a5e&scoped=true&ts=true"
import script from "./NavElement.vue?vue&type=script&lang=ts"
export * from "./NavElement.vue?vue&type=script&lang=ts"

import "./NavElement.vue?vue&type=style&index=0&id=76423a5e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76423a5e"]])

export default __exports__